<template>
    <t-space direction="vertical" align="start" style="width: 100%;">
        <div></div>
        <t-space direction="horizontal">
            <t-space></t-space>
            <t-card 
                    title="仓库管理说明"
                    style="width: 85.5vw;">
                    <t-typography-text>
                        每个账户创建的仓库数量最多只能为
                        <t-typography-text strong>
                            5个
                        </t-typography-text>
                        ，若有更多需求请联系相关工作人员。(删除仓库时，将会删除有关该仓库的全部数据)
                    </t-typography-text>

            </t-card>
            <t-space>
            </t-space>
        </t-space>
        <t-space direction="horizontal">
            <t-space></t-space>
            <t-card style="width: 85.5vw;">
                <t-space direction="vertical">
                    <t-row>
                        <t-col>
                            <t-button @click="()=>{addWarehouseDialogVisible = true}" :disabled="warehouseListData.length >= 5">新增仓库</t-button>
                        </t-col>
                    </t-row>
                    <t-row>
                        <t-table
                                row-key="index"
                                :data="warehouseListData"
                                cell-empty-content="-"
                                :columns="warehouseTableColumns">
                        </t-table>
                    </t-row>
                </t-space>
            </t-card>
            <t-space>
            </t-space>
        </t-space>
        <!--新增仓库信息弹窗-->
        <t-dialog
                header="新增仓库信息"
                :top="'25px'"
                :confirmBtn="null"
                :cancelBtn="null"
                v-model:visible="addWarehouseDialogVisible">
            <t-form 
                    ref="addForm"
                    :data="warehouseAddFormData"
                    :rules="rules"
                    @submit="SubmitWarehouseInfo">
                <t-form-item label="编号" name="warehouseId">
                    <t-input v-model="warehouseAddFormData.warehouseId"></t-input>
                </t-form-item>
                <t-form-item label="名称" name="warehouseName">
                    <t-input v-model="warehouseAddFormData.warehouseName"></t-input>
                </t-form-item>
                <t-form-item label="简称" name="warehouseBriefName">
                    <t-input v-model="warehouseAddFormData.warehouseBriefName"></t-input>
                </t-form-item>
                <t-form-item label="类型" name="warehouseType">
                    <t-input v-model="warehouseAddFormData.warehouseType"></t-input>
                </t-form-item>
                <t-form-item label="拼音码" name="warehousePinYinCode">
                    <t-input v-model="warehouseAddFormData.warehousePinYinCode"></t-input>
                </t-form-item>
                <t-form-item label="负责人" name="warehouseManager">
                    <!-- <t-input v-model="warehouseAddFormData.warehouseManagerId"></t-input> -->
                    <t-select v-model="warehouseAddFormData.warehouseManagerId"  placeholder="请选择"  clearable @change="SelectChange">
                        <t-option v-for="item in userInfoList" :key="item.id" :value="item.id" :label="item.name"></t-option>
                    </t-select>
                </t-form-item>
                <t-form-item label="备注" name="warehouseRemark">
                    <t-input v-model="warehouseAddFormData.warehouseRemark"></t-input>
                </t-form-item>
                <t-form-item label="收货人姓名" name="warehouseConsigneeName">
                    <t-input v-model="warehouseAddFormData.warehouseConsigneeName"></t-input>
                </t-form-item>
                <t-form-item label="收货人电话" name="warehouseConsigneePhoneNumber">
                    <t-input v-model="warehouseAddFormData.warehouseConsigneePhoneNumber"></t-input>
                </t-form-item>
                <t-form-item label="省" name="warehouseProvince">
                    <t-input v-model="warehouseAddFormData.warehouseProvince"></t-input>
                </t-form-item>
                <t-form-item  label="市" name="warehouseCity">
                    <t-input v-model="warehouseAddFormData.warehouseCity"></t-input>
                </t-form-item>
                <t-form-item  label="区" name="warehouseDistrict">
                    <t-input v-model="warehouseAddFormData.warehouseDistrict"></t-input>
                </t-form-item>
                <t-form-item  label="街道" name="warehouseStreetAddress">
                    <t-input v-model="warehouseAddFormData.warehouseStreetAddress"></t-input>
                </t-form-item>
                <t-form-item  label="邮政编码" name="warehouseZipCode">
                    <t-input v-model="warehouseAddFormData.warehouseZipCode"></t-input>
                </t-form-item>
                <t-form-item>
                    <t-button theme="primary" type="submit">提交</t-button>
                </t-form-item>
            </t-form>
        </t-dialog>
        <!--仓库信息详情弹窗-->
        <t-dialog 
            header="仓库详情"
            v-model:visible="warehouseDeatilsDialogVisible"
            :cancelBtn="null"
            @confirm="() => {warehouseDeatilsDialogVisible = false}">
            <t-descriptions>
                <t-descriptions-item label="编号">{{warehouseInfoDetails.warehouseId}}</t-descriptions-item>
                <t-descriptions-item label="名称">{{warehouseInfoDetails.warehouseName}}</t-descriptions-item>
                <t-descriptions-item label="简称">{{warehouseInfoDetails.warehouseBriefName}}</t-descriptions-item>
                <t-descriptions-item label="类型">{{warehouseInfoDetails.warehouseType}}</t-descriptions-item>
                <t-descriptions-item label="拼音码">{{warehouseInfoDetails.warehousePinYinCode}}</t-descriptions-item>
                <t-descriptions-item label="负责人">{{warehouseInfoDetails.warehouseManager}}</t-descriptions-item>
                <t-descriptions-item label="备注">{{warehouseInfoDetails.warehouseRemark}}</t-descriptions-item>
                <t-descriptions-item label="收货人姓名">{{warehouseInfoDetails.warehouseConsigneeName}}</t-descriptions-item>
                <t-descriptions-item label="收货人电话">{{warehouseInfoDetails.warehouseConsigneePhoneNumber}}</t-descriptions-item>
                <t-descriptions-item label="地址">{{warehouseInfoDetails.warehouseAddress}}</t-descriptions-item>
                <t-descriptions-item label="邮政编码">{{warehouseInfoDetails.warehouseZipCode}}</t-descriptions-item>
            </t-descriptions>
        </t-dialog>
        <!--仓库信息修改弹窗-->
        <t-dialog
                    :top="'25px'"
                    header="仓库信息修改"
                    :confirmBtn="null"
                    :cancelBtn="null"
                    v-model:visible="modifiedWarehouseInfoDialogVisible">
                    <t-form 
                        ref="modifyForm"
                        :data="warehouseModifyFormData"
                        :rules="modifyRules"
                        @submit="ModifiedSubmit">
                        <t-form-item label="编号" name="warehouseId">
                            <t-input v-model="warehouseModifyFormData.warehouseId"></t-input>
                        </t-form-item>
                        <t-form-item label="名称" name="warehouseName">
                            <t-input v-model="warehouseModifyFormData.warehouseName"></t-input>
                        </t-form-item>
                        <t-form-item label="简称" name="warehouseBriefName">
                            <t-input v-model="warehouseModifyFormData.warehouseBriefName"></t-input>
                        </t-form-item>
                        <t-form-item label="类型" name="warehouseType">
                            <t-input v-model="warehouseModifyFormData.warehouseType"></t-input>
                        </t-form-item>
                        <t-form-item label="拼音码" name="warehousePinYinCode">
                            <t-input v-model="warehouseModifyFormData.warehousePinYinCode"></t-input>
                        </t-form-item>
                        <t-form-item label="负责人" name="warehouseManager">
                            <!-- <t-input v-model="warehouseAddFormData.warehouseManagerId"></t-input> -->
                            <t-select v-model="warehouseModifyFormData.warehouseManager"  placeholder="请选择"  clearable @change="modifySelectChange">
                                <t-option v-for="item in userInfoList" :key="item.id" :value="item.id" :label="item.name"></t-option>
                            </t-select>
                        </t-form-item>
                        <t-form-item label="备注" name="warehouseRemark">
                            <t-input v-model="warehouseModifyFormData.warehouseRemark"></t-input>
                        </t-form-item>
                        <t-form-item label="收货人姓名" name="warehouseConsigneeName">
                            <t-input v-model="warehouseModifyFormData.warehouseConsigneeName"></t-input>
                        </t-form-item>
                        <t-form-item label="收货人电话" name="warehouseConsigneePhoneNumber">
                            <t-input v-model="warehouseModifyFormData.warehouseConsigneePhoneNumber"></t-input>
                        </t-form-item>
                        <t-form-item label="省" name="warehouseProvince">
                            <t-input v-model="warehouseModifyFormData.warehouseProvince"></t-input>
                        </t-form-item>
                        <t-form-item  label="市" name="warehouseCity">
                            <t-input v-model="warehouseModifyFormData.warehouseCity"></t-input>
                        </t-form-item>
                        <t-form-item  label="区" name="warehouseDistrict">
                            <t-input v-model="warehouseModifyFormData.warehouseDistrict"></t-input>
                        </t-form-item>
                        <t-form-item  label="街道" name="warehouseStreetAddress">
                            <t-input v-model="warehouseModifyFormData.warehouseStreetAddress"></t-input>
                        </t-form-item>
                        <t-form-item  label="邮政编码" name="warehouseZipCode">
                            <t-input v-model="warehouseModifyFormData.warehouseZipCode"></t-input>
                        </t-form-item>
                        <t-form-item>
                            <t-button theme="primary" type="submit">确认修改</t-button>
                        </t-form-item>
                    </t-form>
        </t-dialog>
    </t-space>
</template>
<script lang="jsx" setup>
import { onMounted, ref } from 'vue';
import { NotifyPlugin } from 'tdesign-vue-next';

import request from '@/request/request';


onMounted(()=>{
    request.RequestQueryWarehouseInfo(0,8,{},
    (res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                let info = {}
                info.index = i
                info.warehouseId = data[i].warehouseId
                info.warehouseType = data[i].warehouseType
                info.warehouseName = data[i].warehouseName
                info.warehouseBriefName = data[i].warehouseBriefName
                info.warehousePinYinCode = data[i].warehousePinYinCode
                info.warehouseManager = data[i].warehouseManager
                info.warehouseRemark = data[i].warehouseRemark
                info.warehouseConsigneeName = data[i].warehouseConsigneeName
                info.warehouseConsigneePhoneNumber = data[i].warehouseConsigneePhoneNumber
                info.warehouseAddress = data[i].warehouseAddress
                info.warehouseZipCode = data[i].warehouseZipCode
                warehouseListData.value.push(info)
            }
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '仓库信息请求失败',
                duration: 2000
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '仓库信息请求失败' + err,
            duration: 2000
        })
    })
    request.RequestStaffInfo(0,65535,null,(res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                let value = {}
                value.title = data[i].staffName
                value.content = (data[i].remark === null || data[i].remark === undefined) ? "无详细描述" : data[i].remark
                value.id = data[i].staffId
                value.name = data[i].staffName
                value.brief_name = data[i].briefName
                value.login_password = data[i].loginPassword
                value.phone_number = data[i].staffPhoneNumber
                value.pinyin_code = data[i].pinyinCode
                value.remark = data[i].remark
                value.is_manager = data[i].isManager?"1":"0"
                value.is_login_user = data[i].isLoginUser?"1":"0"
                value.status = data[i].status
                userInfoList.value.push(value)
            }
            console.log("WAREHOUSE MANAGE",userInfoList.value)
        }else {
            NotifyPlugin.error({
                title: "获取员工信息失败",
                message: "获取员工信息失败",
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            theme: '数据获取失败',
            content: '获取员工信息失败' + err,
            duration: 3000
        })
    })
})

const modifiedWarehouseInfoDialogVisible = ref(false)
const userInfoList = ref([])
const currentSelectLable = ref("")
const rules= {
    warehouseId: [
        { required: true, message: '请输入仓库编号',trigger: "submit" },
        { whitespace: true, message: '编号不能为空'}
    ],
    warehouseName:[
        { required: true, message: '请输入仓库名称',trigger: "submit"},
        { whitespace: true, message: '名称不能为空'}
    ]
}
const modifyRules = {
    warehouseId: [
        { required: true, message: '请输入仓库编号',trigger: "submit" },
        { whitespace: true, message: '编号不能为空'}
    ],
    warehouseName:[
        { required: true, message: '请输入仓库名称',trigger: "submit"},
        { whitespace: true, message: '名称不能为空'}
    ],
    warehouseManager:[
        { required: true, message: '请输入负责人',trigger: "submit"},
        { whitespace: true, message: '负责人不能为空'}
    ]
}
const addForm = ref(null)
const modifyForm = ref(null)
const addWarehouseDialogVisible = ref(false)
const warehouseDeatilsDialogVisible = ref(false)
const warehouseInfoDetails = ref({
    warehouseId: "1",
    warehouseType: "1",
    warehouseName: "1",
    warehouseBriefName: "1",
    warehousePinYinCode: "1",
    warehouseManager: "1",
    warehouseRemark: "1",
    warehouseConsigneeName: "1",
    warehouseConsigneePhoneNumber: "1",
    warehouseZipCode: "1",
    warehouseAddress: "1",
})
const warehouseAddFormData = ref({
    warehouseId: "",
    warehouseType: "",
    warehouseName: "",
    warehouseBriefName: "",
    warehousePinYinCode: "",
    warehouseManagerId: "",
    warehouseRemark: "",
    warehouseConsigneeName: "",
    warehouseConsigneePhoneNumber: "",
    warehouseZipCode: "",
    warehouseProvince: "",
    warehouseCity: "",
    warehouseDistrict: "",
    warehouseStreetAddress: "",
})
const warehouseModifyFormData = ref({
    warehouseId: "",
    warehouseType: "",
    warehouseName: "",
    warehouseBriefName: "",
    warehousePinYinCode: "",
    warehouseManager: "",
    warehouseRemark: "",
    warehouseConsigneeName: "",
    warehouseConsigneePhoneNumber: "",
    warehouseZipCode: "",
    warehouseProvince: "",
    warehouseCity: "",
    warehouseDistrict: "",
    warehouseStreetAddress: "",
})
const warehouseListData = ref([
    // {
    //     index: 0,
    //     warehouseId: "1",
    //     warehouseType: "1",
    //     warehouseName: "1",
    //     warehouseBriefName: "1",
    //     warehousePinYinCode: "1",
    //     warehouseAddress: "1",
    //     warehouseManager: "1",
    //     warehouseRemark: "1"
    // }
])
const warehouseTableColumns = [
    {
        title: '仓库编号',
        colKey: "warehouseId"
    },
    {
        title: '仓库类型',
        colKey: "warehouseType"
    },
    {
        title: '仓库名称',
        colKey: "warehouseName",
    },
    {
        title: "简称",
        colKey: "warehouseBriefName",
    },
    {
        title: '拼音码',
        colKey: "warehousePinYinCode"
    },
    {
        title: '仓库地址',
        colKey: "warehouseAddress"
    },
    {
        title: '负责人',
        colKey: "warehouseManager"
    },
    {
        title: '备注',
        colKey: "warehouseRemark"
    },
    {
        title: '操作',
        colKey: "operation",
        fixed: 'right',
        cell: (h, { row }) => {
            return (
                <t-space class="table-operations" space="small">
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={showDeatils}>
                        详情 
                    </t-link>
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={showModified}>
                        修改
                    </t-link>
                    <t-popconfirm content="确认删除吗？" onConfirm={deleteInfo}>
                        <t-link theme="danger" hover="color" data-id={row.index} onClick={()=>{deleteWarehouseClickedCurrent.value = row.index}}>
                            删除
                        </t-link>
                    </t-popconfirm>
                </t-space>
            )
        }
    }
]
const currentModifyIndex = ref()
const currentModifyLable = ref()
const showModified = (e)=>{
    modifiedWarehouseInfoDialogVisible.value = true
    let index = e.currentTarget.dataset.id
    currentModifyIndex.value = index
    warehouseModifyFormData.value.warehouseId = warehouseListData.value[index].warehouseId
    warehouseModifyFormData.value.warehouseType = warehouseListData.value[index].warehouseType
    warehouseModifyFormData.value.warehouseName = warehouseListData.value[index].warehouseName
    warehouseModifyFormData.value.warehouseBriefName = warehouseListData.value[index].warehouseBriefName
    warehouseModifyFormData.value.warehousePinYinCode = warehouseListData.value[index].warehousePinYinCode
    // warehouseModifyFormData.value.warehouseManager = warehouseListData.value[index].warehouseManager
    warehouseModifyFormData.value.warehouseRemark = warehouseListData.value[index].warehouseRemark
    warehouseModifyFormData.value.warehouseConsigneeName = warehouseListData.value[index].warehouseConsigneeName
    warehouseModifyFormData.value.warehouseConsigneePhoneNumber = warehouseListData.value[index].warehouseConsigneePhoneNumber
    warehouseModifyFormData.value.warehouseZipCode = warehouseListData.value[index].warehouseZipCode
    if( warehouseListData.value[index].warehouseAddress) {
        warehouseModifyFormData.value.warehouseProvince = warehouseListData.value[index].warehouseAddress.split("省")[0] + "省"
        if(warehouseListData.value[index].warehouseAddress.split("省")[1]) warehouseModifyFormData.value.warehouseCity = warehouseListData.value[index].warehouseAddress.split("省")[1].split("市")[0] + "市"
        if(warehouseListData.value[index].warehouseAddress.split("省")[1].split("市")[1]) warehouseModifyFormData.value.warehouseDistrict = warehouseListData.value[index].warehouseAddress.split("省")[1].split("市")[1].split("区")[0] + "区"
        if(warehouseListData.value[index].warehouseAddress.split("省")[1].split("市")[1].split("区")[1] ) warehouseModifyFormData.value.warehouseStreetAddress = warehouseListData.value[index].warehouseAddress.split("省")[1].split("市")[1].split("区")[1] 
    }else {
        warehouseModifyFormData.value.warehouseProvince = ""
        warehouseModifyFormData.value.warehouseCity = ""
        warehouseModifyFormData.value.warehouseDistrict = ""
        warehouseModifyFormData.value.warehouseStreetAddress = ""
    }
}

const ModifiedSubmit = ({ validateResult, firstError })=>{
    if(validateResult === true) {
        request.RequestModifiedWarehouseInfo(warehouseListData.value[currentModifyIndex.value].warehouseId,warehouseModifyFormData,(res)=>{ //TODO
            if(res.data.success) {
                NotifyPlugin.success({
                    title: "修改成功",
                    message: "仓库信息修改成功",
                    duration: 3000
                })
                modifiedWarehouseInfoDialogVisible.value = false
                warehouseListData.value[currentModifyIndex.value].warehouseId = warehouseModifyFormData.value.warehouseId
                warehouseListData.value[currentModifyIndex.value].warehouseType = warehouseModifyFormData.value.warehouseType
                warehouseListData.value[currentModifyIndex.value].warehouseName = warehouseModifyFormData.value.warehouseName 
                warehouseListData.value[currentModifyIndex.value].warehouseBriefName = warehouseModifyFormData.value.warehouseBriefName
                warehouseListData.value[currentModifyIndex.value].warehousePinYinCode = warehouseModifyFormData.value.warehousePinYinCode
                warehouseListData.value[currentModifyIndex.value].warehouseManager = warehouseModifyFormData.value.warehouseManager
                warehouseListData.value[currentModifyIndex.value].warehouseRemark = warehouseModifyFormData.value.warehouseRemark
                warehouseListData.value[currentModifyIndex.value].warehouseConsigneeName = warehouseModifyFormData.value.warehouseConsigneeName
                warehouseListData.value[currentModifyIndex.value].warehouseConsigneePhoneNumber = warehouseModifyFormData.value.warehouseConsigneePhoneNumber
                warehouseListData.value[currentModifyIndex.value].warehouseZipCode = warehouseModifyFormData.value.warehouseZipCode
                warehouseListData.value[currentModifyIndex.value].warehouseAddress = warehouseModifyFormData.value.warehouseProvince + warehouseModifyFormData.value.warehouseCity + warehouseModifyFormData.value.warehouseDistrict + warehouseModifyFormData.value.warehouseStreetAddress
                warehouseListData.value[currentModifyIndex.value].warehouseManager = currentModifyLable.value
            }else {
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '修改仓库信息失败。',
                    duration: 3000
                })
            }
        },
        (err)=>{
            NotifyPlugin.error({
                title: "修改失败",
                content: '仓库信息修改失败。' + err,
                duration: 3000
            })
        }
    )}else{
        NotifyPlugin.warning({
            title: "修改失败",
            content: firstError,
            duration: 3000
        })
    }
}

const SubmitWarehouseInfo = ({ validateResult, firstError })=>{
    if (validateResult === true) {
        request.RequestCreateWarehouse(warehouseAddFormData,
        (res)=>{
            if(res.data.success) {
                NotifyPlugin.success({
                    placement: 'top-right',
                    title: '添加成功',
                    content: '仓库添加成功',
                    duration: 3000,
                })
                addWarehouseDialogVisible.value = false
                let info = []
                info.index = warehouseListData.value.length
                info.warehouseId = warehouseAddFormData.value.warehouseId
                info.warehouseType = warehouseAddFormData.value.warehouseType
                info.warehouseName = warehouseAddFormData.value.warehouseName
                info.warehouseBriefName = warehouseAddFormData.value.warehouseBriefName
                info.warehousePinYinCode = warehouseAddFormData.value.warehousePinYinCode
                info.warehouseManager = currentSelectLable.value //TODO
                info.warehouseRemark = warehouseAddFormData.value.warehouseRemark
                info.warehouseZipCode = warehouseAddFormData.value.warehouseZipCode
                info.warehouseAddress = warehouseAddFormData.value.warehouseProvince + warehouseAddFormData.value.warehouseCity + warehouseAddFormData.value.warehouseDistrict + warehouseAddFormData.value.warehouseStreetAddress
                warehouseListData.value.push(info)
            } else {
                NotifyPlugin.error({
                    placement: 'top-right',
                    title: '添加失败',
                    content: '仓库添加失败',
                    duration: 3000,
                })
            }
        },(err)=>{
            NotifyPlugin.error({
                    placement: 'top-right',
                    title: '添加失败',
                    content: '仓库添加失败' + err,
                    duration: 3000,
                })
        })
    }else{
        NotifyPlugin.warning({
            placement: 'top-right',
            title: firstError,
            duration: 3000
        })
    }
}

const showDeatils = (e)=>{
    const index = e.currentTarget.dataset.id
    console.log(index)
    warehouseDeatilsDialogVisible.value = true
    warehouseInfoDetails.value.warehouseId = warehouseListData.value[index].warehouseId
    warehouseInfoDetails.value.warehouseType = warehouseListData.value[index].warehouseType
    warehouseInfoDetails.value.warehouseName = warehouseListData.value[index].warehouseName
    warehouseInfoDetails.value.warehouseBriefName = warehouseListData.value[index].warehouseBriefName
    warehouseInfoDetails.value.warehousePinYinCode = warehouseListData.value[index].warehousePinYinCode
    warehouseInfoDetails.value.warehouseManager = warehouseListData.value[index].warehouseManager
    warehouseInfoDetails.value.warehouseRemark = warehouseListData.value[index].warehouseRemark
    warehouseInfoDetails.value.warehouseConsigneeName = warehouseListData.value[index].warehouseConsigneeName
    warehouseInfoDetails.value.warehouseConsigneePhoneNumber = warehouseListData.value[index].warehouseConsigneePhoneNumber
    warehouseInfoDetails.value.warehouseZipCode = warehouseListData.value[index].warehouseZipCode
    warehouseInfoDetails.value.warehouseAddress = warehouseListData.value[index].warehouseAddress
}

const deleteWarehouseClickedCurrent = ref(-1)
const deleteInfo = ()=>{
    // const id = e.currentTarget.dataset.id
    const id = deleteWarehouseClickedCurrent.value
    console.log(id)
    request.RequestDeleteWarehouseInfo(warehouseListData.value[id].warehouseId,
    (res)=>{
        if(res.data.success) {
            warehouseListData.value.splice(id,1)
            for(let i = id; i < warehouseListData.value.length; i++) {
                warehouseListData.value[i].index = i
            }
            NotifyPlugin.success({
                placement: 'top-right',
                title: '删除成功',
                content: '仓库删除成功',
                duration: 3000,
            })
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '删除失败',
                content: '仓库删除失败',
                duration: 3000,
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
                    placement: 'top-right',
                    title: '删除失败',
                    content: '仓库删除失败' + err,
                    duration: 3000,
                })
    })
}
const SelectChange = (value,context)=>{
    if(context.option) {
        currentSelectLable.value = context.option.label
        warehouseAddFormData.value.warehouseManagerId = value
    } 
}

const modifySelectChange = (value,context)=>{
    if(context.option) {
        currentModifyLable.value = context.option.label
        warehouseModifyFormData.value.warehouseManager = value
    } 
}

</script>
<style scoped>

</style>